import { AttributesFiltersEntity } from "@apps/reviews/entities/AttributesFiltersEntity";
import { AttributesFiltersSchema } from "@apps/reviews/schemas/AttributesFiltersSchema";
import { applyTransaction } from "@datorama/akita";
import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { create } from "superstruct";
import { injectable } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import ReviewsFilterStore from "../stores/ReviewsFilterStore";

type ReviewsFilterParams = {
    productId: number;
};

@injectable()
class ReviewsFilterService {
    constructor(
        private readonly reviewsFilterStore: ReviewsFilterStore,
        private readonly authApiClient: ApiClientInterface,
        private readonly logger: LoggerInterface
    ) {}

    getAttributeFilters({
        productId,
    }: ReviewsFilterParams): Observable<AttributesFiltersEntity> {
        return this.authApiClient
            .get({
                url: "/review/getAttributeFilters",
                queryParams: { productId },
            })
            .pipe(
                map((v) => create(v.body, AttributesFiltersSchema)),
                catchError((error: unknown) => {
                    this.logger.debug(
                        "ReviewsFilterService.getAttributeFilters is errored",
                        {
                            productId,
                            error,
                        }
                    );

                    throw error;
                }),
                tap((data) => {
                    this.logger.debug(
                        "ReviewsFilterService.getAttributeFilters is ready",
                        productId
                    );
                    applyTransaction(() => {
                        this.reviewsFilterStore.update((state) => {
                            state.data = data;
                        });
                    });
                })
            );
    }

    updateFilterReview({ isFilter }: { isFilter?: boolean }) {
        applyTransaction(() => {
            this.reviewsFilterStore.update((state) => ({
                ...state,
                isFilter: isFilter,
            }));
        });
    }
}

export default ReviewsFilterService;
